<script lang="ts" setup>
import { omit, pick } from 'lodash-es';
import { getNavigationConfig } from '~/configs/navigation';

const navigationConfig = getNavigationConfig();
const iconNav: string[] = ['home', 'notifications'];

const requiredConfig = pick(navigationConfig, iconNav);
const desktopConfig = omit(navigationConfig, iconNav);
</script>
<template>
    <div class="row items-center q-mr-md">
        <template v-for="(nav, navKey) in requiredConfig" :key="navKey">
            <app-header-navigation-item :nav-key="navKey" :nav="nav" />
        </template>
    </div>
    <div class="row items-center q-gutter-md gt-md">
        <template v-for="(nav, navKey) in desktopConfig" :key="navKey">
            <app-header-navigation-item :nav-key="navKey" :nav="nav" />
        </template>
    </div>
</template>
